// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileTwoToneSvg from "@fishx/icons-svg/es/asn/FileTwoTone";
import FishxIcon from '../components/FishxIcon';

var FileTwoTone = function FileTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileTwoToneSvg
  }));
};

FileTwoTone.displayName = 'FileTwoTone';
export default React.forwardRef(FileTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileTwoTone.js
// module id = 2747
// module chunks = 0